import React from "react";

import { ModalTypes } from "constants/navigation";

import { EditCheckpointModal } from "./Modal";

export function Adapter(props) {
  const { hash } = props;
  const hashParams = hash[ModalTypes.EditCheckpoint] || null;
  const [checkpointId, options] = JSON.parse(hashParams);
  const { returnTo } = hash;
  const decodedReturnTo = returnTo ? atob(returnTo) : "";

  return (
    <EditCheckpointModal
      checkpointId={checkpointId}
      options={options}
      returnTo={decodedReturnTo}
    />
  );
}
